var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgButtonOutline = function SvgButtonOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 14.25v-1.5h-1.5A.73.73 0 0 1 5 12a.73.73 0 0 1 .75-.75h1.5v-1.5A.73.73 0 0 1 8 9a.73.73 0 0 1 .75.75v1.5h1.5A.73.73 0 0 1 11 12a.73.73 0 0 1-.75.75h-1.5v1.5A.73.73 0 0 1 8 15a.73.73 0 0 1-.75-.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8v8.02c0 1.1-.9 1.98-2 1.98H4c-1.1 0-2-.88-2-1.98V8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2m-3-.02H5c-.55 0-1 .45-1 1v6.05c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V8.98c0-.55-.45-1-1-1"
  })));
};
export default SvgButtonOutline;